<template>
    <common-modal :showCloseIcon="true" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-page-header
                size="small"
                :heading="$t('forms.offer.discount_offer.discount_title')"
                :isCenter="true"
            ></common-page-header>
            <add-offer-discount-form
                :offers="offers"
                :prefill="prefill"
                @discount-added="emitEvent({ name: 'discount-added' })"
            ></add-offer-discount-form>
        </common-content-wrapper>
    </common-modal>
</template>
<script>
    import AddOfferDiscountForm from 'components/forms/offer/AddOfferDiscountForm'
    export default {
        components: {
            AddOfferDiscountForm,
        },
        props: {
            offers: { type: Array, required: true },
            prefill: { type: Object, default: undefined },
        },
    }
</script>
